import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../components/button/button";
import { Element, elements } from "./elements";
import styles from "./successful-activation-modal.module.scss";
import Event from "../../../../../../core/consts/analytics-events";
import NavBar from "../../../../../../components/nav-bar/nav-bar";
import Modal from "../../../../../../components/modal/modal";
import { useDI } from "../../../../../../core/di";

interface Props {
  onClose: () => void;
  onFinish: () => void;
}

export function SuccessfulActivationModal(props: Props) {
  const { onClose, onFinish } = props;
  const { t } = useTranslation();
  const { analytics } = useDI();

  useEffect(() => {
    analytics?.track(Event.SuccessModalViewed);
  }, []);

  const renderElements = () => {
    return elements.map((element: Element, index) => (
      <div className={styles.ElementWrapper} key={index}>
        <img
          src={element.icon}
          width="80px"
          height="80px"
          alt={element.title}
        />
        <div>
          <p className={styles.Title}>{t(element.title)}</p>
          <p className={styles.Description}>{t(element.description)}</p>
        </div>
      </div>
    ));
  };

  const handleFinishAndCloseModal = () => {
    analytics?.track(Event.SuccessModalSubmitClicked);
    onFinish();
  };

  const footer = () => {
    return (
      <footer className={styles.Footer}>
        <Button action={handleFinishAndCloseModal}>{t("gotIt")}</Button>
      </footer>
    );
  };

  const handleCloseModal = () => {
    analytics?.track(Event.SuccessModalXClicked);
    onClose();
  };

  return (
    <Modal
      fullWidth={true}
      title={t("allSet")}
      data-testid={"subscription-active"}
    >
      <p className={styles.P}>{t("youNowHaveAccessTo")}</p>
      {renderElements()}
      {footer()}
    </Modal>
  );
}

export default SuccessfulActivationModal;
